(ns boot.fx
  (:require
    [oops.core :refer [oset!]]
    [day8.re-frame.async-flow-fx]
    [very.re-frame.core :as rf]))

(defn alert [cfg]
  (js/alert (:message cfg))
  (rf/>evt (:after cfg)))

(defn insert-script-fx [{:keys [src on-load]}]
  (let [ele (.createElement js/document "script")]
    (.setAttribute ele "src" src)
    (oset! ele "onload" #(rf/>evt on-load))
    (.appendChild (.-body js/document) ele)))

(defn domain [cfx _]
  (assoc cfx :domain (.. js/document -location -hostname)))
